<template>
  <div class="meeting_group">
    <div class="form_box">
      <el-form :model="forms" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
        :label-position="'left'">
        <div class="form_top">
              <div class="form_top_right">
            <el-form-item label="选择客户" prop="customerIds" >
              <el-select
                class="inputWith"
                v-model="forms.customerIds"
                placeholder="请选择客户"
                filterable
                multiple
                :disabled="false"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.customerName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form_btn">
          <el-form-item>
            <el-button type="primary" @click="handleSubmit()">保存 </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      forms: {
        customerIds: [] // 选择的客户，多选
      },
      customerList: [],
    };
  },
  props: ["onCancel", "consumableInventory"],
  created() {
    this.getCustomerList();
  },
  methods: {
    async getCustomerList() {
      let q = {};
      let res = await $utils.api.load("/admin/system/customer/list", q, "get");
      if (res && res.rows) {
        this.customerList = res.rows;
      }
    },
    handleSubmit() {
      const requestData = Object.assign({}, this.forms);
      // 仅在存在有效值时添加 consumableInventory 字段
      if (Array.isArray(this.consumableInventory) && this.consumableInventory.length > 0) {
        requestData.consumableInventory = this.consumableInventory;
      } else {
        requestData.consumableInventory = [];
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/inventory/implCommonAdmin`, q, "post")
            .then((res) => {
              this.sloading = false;
              if (res.status || res.code === 200) {
                $utils.toast.success("保存成功");
                this.$emit("onCancel");
                $utils.url.go(0);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.meeting_group {
  .form_box {
    .inputWith {
      width: 700px;
    }

    .inputWithTime {
      width: 200px;
    }

    .form_top,
    .form_bottom {
      display: flex;
    }

    .form_top {
      margin-bottom: 40px;

      .facilityType_class {
        padding-left: 100px;
        color: red;
        cursor: pointer;
      }

      .center-02 {
        width: 300px;
        border-radius: 10px;
        padding: 10px;
        box-sizing: border-box;
        box-shadow: 1px 2px 5px #8c939d;
        margin-left: 10px;
      }
    }

    .form_top_left,
    .form_bottom_left {
      width: 150px;
    }

    .form_top_left_text,
    .form_bottom_left_text {
      height: 40px;
      line-height: 40px;
      margin: 0 40px;
    }

    .form_bottom {
      margin-bottom: 20px;
    }

    .form_btn {
      margin-left: 150px;
    }
  }
}
</style>
